import * as React from 'react';
import { countryColor } from 'constants/countryColors';
import { COUNTRY_SHAPES, VIEW_BOX } from './southAmerica';
import styles from './styles.module.scss';

interface Props {
  /** Acciones per country, by ISO code. */
  counts: Record<string, number>;
  /** Accessible description, e.g. "Argentina 53, Chile 16". */
  label: string;
}

// Bubble centers in map units, where the XD places them.
const BUBBLES: Record<string, [number, number]> = { CL: [47, 205], BR: [222, 152], PY: [128, 176], AR: [115, 291] };

/** The corridor countries on a simplified South America, each with its number of Acciones. */
const CountryMapChart = ({ counts, label }: Props) => (
  <svg className={styles.map} viewBox={VIEW_BOX} role="img" aria-label={label}>
    {COUNTRY_SHAPES.map(({ code, d }, index) => (
      <path
        // eslint-disable-next-line react/no-array-index-key
        key={index}
        d={d}
        fill={countryColor(code).fill}
        className={code && !counts[code] ? styles.empty : undefined}
      />
    ))}
    {Object.entries(BUBBLES).map(([code, [x, y]]) => {
      const count = counts[code] || 0;
      const radius = Math.max(17, 7 + 6.5 * String(count).length);
      const color = countryColor(code);
      return (
        <g key={code} className={count ? undefined : styles.empty} aria-hidden="true">
          <circle cx={x} cy={y} r={radius} className={styles.bubble} stroke={color.fill} />
          <text x={x} y={y} className={styles.count} fill={color.text}>{count}</text>
        </g>
      );
    })}
  </svg>
);

export default CountryMapChart;
